import TAGGED from "../modules/tagged_content"
import CONTENT_HEADER from '../plugins/content_header'
import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, l, content ] = [ window, document, location, 'case' ]

const init = () => {
  CONTENT_HEADER()
}

// 詳細ページにて実行
const detail_init = async post_id => {
  let articles = await $.getArticles({ content, post_status: 'all' })
  let categories = await $.getCategories({ content })
  let the_article = articles.filter( a => (a.id == post_id) ).shift()
  the_article.category = categories.filter( c => c.id == the_article.category )[0]

  // タグボックス
  let tags = keywords => {
    let html = ""
    if(!keywords || keywords.length == 0) return ''
    keywords.forEach( key => html += `<a href="/${content}/?mode=list&tag=${ encodeURI( key ) }" class="button-tag">${key}</a>` )
    return `<div class="p-taglist">${html}</div>`
  }
  $('.element_detail .entry').append( tags( the_article.keywords ) )

  // 詳細置き換え
  $('.contents > .detail_title').each( ( i, detail_title ) => {
    let $taglist = $(`
      ${tags( the_article.keywords )}
    `)
    $('.contents .datetop').hide()

    $taglist.appendTo( detail_title )
  })

}

export default function CASE () {
  w.jQuery = $

  // 一覧ページのテンプレート(Vue template)
  const itemTemplate = `
  <div id="main" class="column-3-4">
    <transition-group class="p-list" tag="div" name="fade" mode="out-in">
      <a class="p-item" :href="article.href" v-for="article in pagedArticles" :key="article.id">
        <figure class="p-item__img" :style="'background-image:url(' + article.thumb + ')'">
          <span class="category" :class="'is-cat'+article.category.id" v-if="article.category">{{ article.category.name }}</span>
          <img :src="article.thumb" width="200">
        </figure>
        <div class="p-item__body">
          <span class="date">{{ datetostr( article.date * 1000, 'YYYY.MM.DD' ) }}</span>
          <h5 class="p-item__title">
            <span class="subject">{{ article.title | truncate }}</span>
            <span class="new" v-if="article.is_new">NEW</span>
          </h5>
          <div class="p-item__tags" v-if="article.keywords != null">
            <span v-for="keyword in article.keywords" class="button button-xsmall">{{keyword}}</span>
          </div>
        </div>
      </a>
    </transition-group>
    <pagination
      v-if="totalPage > 1"
      :paged="paged"
      :total-page="totalPage"
      :total-item="totalItem"
      :item-count="pagedArticles.length"
      :prevText="'Prev'"
      :nextText="'Next'"
      @change="pageChange"
    />
  </div>
  `

    // カテゴリ一覧ページにて、記事ごとの要素置き換え
    const replaceItemTemplate = item => `
    <a class="p-item" href="${item.href}">
      <figure class="p-item__img" style="background-image:url( ${item.thumb} )">
        <img src="${item.thumb}" width="200">
      </figure>
      <div class="p-item__body">
        ${(item.date)? `<small class="date">${item.date.replace( /\//g, '.' )}</small>`: ''}
        <h5 class="p-item__title">
          <span class="subject">
           ${item.title.str_truncate( 20 )}
          </span>
          ${item.is_new ? '<span class="new">NEW</span>': ''}
        </h5>
      </div>
    </a>
  `

  // 関連記事のテンプレート(Vue template)
  const relatedItemTemplate = `
    <div class="p-case-related-list" v-if="relatedArticles.length >= 1">
      <a class="p-case-related-item" :href="article.href" v-for="article in relatedArticles" :key="article.id">
        <figure class="p-case-related-item__img" :style="'background-image:url(' + article.thumb +')'"><img :src="article.thumb" width="200"></figure>
        <div class="p-case-related-item__body">
          <h5 class="p-case-related-item__title">
          {{ article.title }}
          </h5>
        </div>
      </a>
    </div>
  `

  TAGGED({
    perpage: 9,
    related: true,
    taglist_disp_list: true, // head / foot / both
    taglist_disp_detail: 'foot', // head / foot / both
    taglist_minimumTagAmount : 12, // タグの最低表示数
    taglist_hideUselessTags : 4, // 最低使用回数
    itemTemplate,
    replaceItemTemplate,
    relatedItemTemplate
  })

  $(() => {

    init()
    if( w.query_string('article') ) detail_init( w.query_string('article') )

    // リスト・詳細コンテナのクラス変更

    if( (/article=\d+/).test( l.search ) ){ // 詳細ページだったら
      const detail_title = d.querySelector('.hs_entrytitle')
      const id = l.search.match(/article=(\d+)/)[1]
      detail_title .classList.remove('hs_entrytitle');
      detail_title .classList.add('p-case__title');
      if (!$.UA.is_mobile){
        $('.p-case__title').insertAfter('.mainImg')
        $('.p-case__title').attr({
          'data-plugin':"getArticles",
          'data-content': "case",
          'data-articles': id,
          'data-amount': 1,
        });
      }else{
        $('.p-case__title').insertBefore('.titleTxt')
        $('.p-case__title').attr({
          'data-plugin':"getArticles",
          'data-content': "case",
          'data-articles': id,
          'data-amount': 1,
        });
      }
      GET_ARTICLES('.p-case__title[data-plugin="getArticles"]',{
        makeItem(item,opt){
          const newitem = (item.is_new)? 'NEW':''
          return $(`<div class="title-inner">
          <h5 class="category">${item.category.name}</h5>
          <div class="title-detail">
            <small class="date">${item.date}</small>
            <strong class="title">${item.title}</strong>
            <small class="new">${newitem}</small>
          </div>
          </div>`)[0]
        }
      })
    }
    if( (/cat=\d+/).test( l.search ) ){ // カテゴリ一覧ページだったら
      $('.element_list .contents').attr('class', 'contents')
      $('.artloop', '.element_list').removeAttr('style')
    }

    w.load['footer'].done(()=>{
      if($.UA.is_mobile){
        $('.detailFooter').prepend(`<a class="p-case__back icon-list" href="/case/" rel="external" title="記事一覧に戻る">記事一覧に戻る</a>`);
      }
    })

  })

  w.addScript({
    src: '/asset/js/vendor/jquery.event.move.js'
  })
  w.addScript({
    src: '/asset/js/vendor/jquery.twentytwenty.js'
  })
  $(w).on('load', () =>{
    $("#detailimage").twentytwenty();
  })

}